module.exports = __webpack_public_path__ + "img/wave.d9925927.svg";